import { renderToString } from "react-dom/server";
import { Column } from "./DataTable.type";

export const getText = (node) => {
  const txt = renderToString(node);

  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(txt, "text/html");
  return htmlDoc.documentElement.textContent;
};

// Tables use table-layout: fixed so a column's width never grows with its
// body content. With table-layout: fixed the browser only reads widths off
// the FIRST table row — normally the header — so when a page hides its
// <thead> via CSS (e.g. Catalogues) that role silently falls to the first
// body row instead. Both Thead and TBody call this so column widths stay
// correct either way. Values are weights (minWidth/maxWidth/width, 125
// fallback) in px, treated as each column's minimum width.
const getColumnWeights = (thead: Column[]): number[] =>
  thead.map(
    (column) => column.width ?? column.maxWidth ?? column.minWidth ?? 125
  );

// Widths as a % of the sum of all columns, so the table fills its container
// instead of leaving dead space when there's room for every column's weight.
export const getColumnWidths = (thead: Column[]): string[] => {
  const weights = getColumnWeights(thead);
  const total = weights.reduce((sum, w) => sum + w, 0);
  return weights.map((w) => `${(w / total) * 100}%`);
};

// Sum of the column weights in px. Applied as the <table>'s own min-width so
// that once the container is too narrow to give every column its weight at
// their % share above, the table grows past the container's edge instead of
// squeezing columns below their minimum — the container's overflow-x: auto
// then turns that into a horizontal scrollbar.
export const getTableMinWidth = (thead: Column[]): number =>
  getColumnWeights(thead).reduce((sum, w) => sum + w, 0);
